/**
 * The dashboard's root.
 *
 * Resolves the path, then decides whether the screen wears the authenticated
 * shell. The four auth screens do not — a signed-out person never sees a
 * sidebar — and everything else does (Story 3.8, DECISION-018).
 *
 * The document title is set per route rather than left at the static one in
 * `index.html`: a browser tab reading "Leadgible" for every screen is a tab
 * nobody can find among nine others.
 */
import { useEffect } from 'react'
import { resolve } from './routes'
import { AppShell } from './shell/AppShell'

export function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/'
  const route = resolve(path)
  const Screen = route.element

  useEffect(() => {
    document.title = `${route.title} · Leadgible`
  }, [route.title])

  if (!route.shell) return <Screen />

  return (
    <AppShell path={route.path} settings={route.settings ?? false} bare={route.bare ?? false}>
      <Screen />
    </AppShell>
  )
}
